// ==========================================================================
// groots Starter Kit
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Require Groots core JS
import 'groots/core';

// Display debug informations
window.groots.verbose = false;

// Require responsive helpers
import 'groots/responsive';

// Require Groots JS plugins
import 'groots/buds/grFormNormalize/grFormNormalize';
import 'groots/buds/grNavigation/grNavigation';
import 'groots/buds/grSVGInliner/grSVGInliner';
// import 'groots/buds/grFormUpload/grFormUpload';


import './_gr-popup';
import './_events';
import './_navigation';
import './_mobile-navigation';
import './_hubspot-search';
import './_popup';
